/**
 * Configuration constants for the FilePreviewer component
 * Contains values that may need to be changed or are used in multiple places
 */

// ===== Zoom Configuration =====

export const ZOOM_CONFIG = {
  MIN: 50,
  MAX: 150,
  STEP: 10,
  DEFAULT: 100,
};

// ===== Default Accepted Types =====

export const DEFAULT_ACCEPTED_TYPES = "application/pdf,.png,.jpg,.jpeg" as const;

// ===== CSS Classes =====

export const CSS_CLASSES = {
  CONTAINER: "file-previewer-container",
  BUTTONS: "file-previewer-buttons",
  TITLE: "file-previewer-title",
  BUTTON_GROUP: "file-previewer-button-group",
  ICON_BUTTON: "file-previewer-icon-btn",
  VIEWER: "file-previewer-viewer",
  FULLSCREEN_OVERLAY: "file-previewer-fullscreen-overlay",
  FULLSCREEN_CONTAINER: "file-previewer-fullscreen-container",
  REACT_FILE_VIEWER: "react-file-viewer",
  IMAGE_ZOOM_CONTAINER: "image-zoom-container",
  DOCUMENT_ZOOM_CONTAINER: "document-zoom-container",
} as const;

// ===== Timing Constants =====

export const TIMING = {
  ZOOM_DEBOUNCE_MS: 100,
  PRINT_DELAY_MS: 100,
  BLOB_CLEANUP_DELAY_MS: 100,
} as const;
